import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { FC } from 'react';

type TProps = {
  showMore: boolean;
};

const ChevronArrow: FC<TProps> = ({ showMore }) =>
  showMore ? (
    <KeyboardArrowUp className="tw:text-secondary-600 tw:hover:text-secondary-200" />
  ) : (
    <KeyboardArrowDown className="tw:text-secondary-600 tw:hover:text-secondary-200" />
  );

export default ChevronArrow;
